import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Server, Home } from 'lucide-react';

const ServerError = ({ errorMessage, isAdmin }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="flex justify-center">
          <Server className="h-24 w-24 text-red-500" />
        </div>
        <h1 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-gray-100">
          {t('Server Error')}
        </h1>
        <p className="mt-2 text-lg text-gray-600 dark:text-gray-300">
          {isAdmin ? errorMessage : t('A server error has occurred. Please return home and try again later.')}
        </p>
        <div className="mt-5">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm dark:shadow-gray-900/20 text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition duration-150 ease-in-out"
          >
            <Home className="mr-2 -ml-1 h-5 w-5" aria-hidden="true" />
            {t('Return Home')}
          </Link>
        </div>
      </div>
      {!isAdmin && (
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t('If this error persists, please contact support.')}
          </p>
        </div>
      )}
    </div>
  );
};

export default ServerError;
